// Build-time constants for the staging build (project.json's `staging`
// configuration replaces environment.ts with this file).
//
// Identical to environment.prod.ts, and that is the design rather than an
// oversight: everything that actually differs between whitelabel's staging and
// production hosts -- API origin, locales, Pusher app -- is served at runtime as
// SERVER_CONFIG from /env.config.js, generated per hostname from
// config/<tier>/hosts/<hostname>/env.config.js. Only values the bundle
// must be compiled with belong here.
//
// `production: true` is deliberate. It is what enables Angular's production mode
// in a deployed build; staging is a deployed build.
export const environment = {
  production: true,
  test: false,
  web: true,
  isCB: false,
  sentryUrl: null,
  sentryShowDialog: false,
  imageServer: 'https://d20xk4sxen1bs2.cloudfront.net',
  includeLegs: true
};
